import { orchestrator } from 'satcheljs';
import { onAnswerRendered } from 'owa-mail-search';
import { setIsAnswerRendered } from '../actions/internalActions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getScenarioStore, SearchScenarioId } from 'owa-search';
import { lazyLogClientLayout } from 'owa-search-instrumentation';
import { listViewStore } from 'owa-mail-list-store';
import { SubstrateSearchScenario } from 'owa-search-service';
import { getResultsView } from '../helpers/getResultView';

export default orchestrator(onAnswerRendered, actionMessage => {
    setIsAnswerRendered(true);
    logClientLayoutForAnswerBlock();
});

function logClientLayoutForAnswerBlock(): void {
    if (isFeatureEnabled('sea-instv2')) {
        const { currentSearchQueryId, tableViewId } = getScenarioStore(SearchScenarioId.Mail);
        const tableView = listViewStore.tableViews.get(tableViewId);
        const resultsView = getResultsView(tableView);
        lazyLogClientLayout.importAndExecute(
            SubstrateSearchScenario.Mail,
            null /* Puid */,
            null /* TenantId */,
            currentSearchQueryId,
            currentSearchQueryId,
            'Vertical',
            resultsView
        );
    }
}
